import { observer } from "mobx-react-lite";
import { CheckCircle2, Info, XCircle } from "lucide-react";
import { createPortal } from "react-dom";
import { useStore } from "../../stores/rootStore";
import type { ToastKind } from "../../stores/uiStore";

const ICONS = {
	info: Info,
	success: CheckCircle2,
	error: XCircle,
} as const;

const COLORS: Record<ToastKind, string> = {
	info: "text-brand",
	success: "text-teal",
	error: "text-danger",
};

export const Toaster = observer(() => {
	const { ui } = useStore();
	if (ui.toasts.length === 0 || typeof document === "undefined") return null;

	return createPortal(
		<div className="pointer-events-none fixed inset-x-0 bottom-6 z-[100] flex flex-col items-center gap-2 px-4">
			{ui.toasts.map((toast) => {
				const Icon = ICONS[toast.kind];
				return (
					<button
						key={toast.id}
						type="button"
						onClick={() => ui.dismiss(toast.id)}
						className="glass animate-fade-up pointer-events-auto flex items-center gap-2 rounded-full border border-line px-4 py-2.5 text-sm shadow-[var(--shadow-panel)]"
					>
						<Icon size={16} className={COLORS[toast.kind]} />
						{toast.message}
					</button>
				);
			})}
		</div>,
		document.body,
	);
});
